import BootstrapModal from "../../components/BootstrapModal";
import {Formik, Form, Field, ErrorMessage} from 'formik'
import TextField from "../../components/TextField";
import * as Yup from 'yup'
import PMSCheckBox from "../../components/PMSCheckBox";
import FormSelect from "../../components/FormSelect";
import {ProgressSpinner} from "primereact/progressspinner";
import {useState} from "react";

const AssestmentTitleForm = ({modal, assestmentTitleID, assestmentID,assestmentTitleName,defination,definationBangla,indicatorName,active, isLoading,activeAssestmentNames, onSubmit, onHide}) => {

   /* const [initialValues,setInitValue] = useState({assestmentTitleID: assestmentTitleID, assestmentID: assestmentID,
        assestmentTitleName: assestmentTitleName,
        defination: defination,
        definationBangla: definationBangla,indicatorName: indicatorName, active: active})
*/
    const validation = Yup.object({
        assestmentID: Yup.string().required(),
        assestmentTitleName: Yup.string().required("This field is required"),
        defination: Yup.string().required("This field is required"),
        //definationBangla:  Yup.string().required("This field is required"),
        indicatorName: Yup.string().required("This field is required")
    })

/*    const onAssessmentChange = e =>{
        console.log(e.currentTarget.value)
        const assessment = activeAssestmentNames.filter(item=> parseInt(item.value) === parseInt(e.currentTarget.value))
        console.log(assessment)
        if (assessment.length > 0){
           // setLecalAssestmentTitleName(assessment[0].label)
            setInitValue({...initialValues,assestmentTitleName:assessment[0].label})
        }

    }*/
    return (<>
        <BootstrapModal headerText="Add Assessment Title" size={30} visible={modal} onHide={onHide}>
            <Formik
                validationSchema={validation}
                initialValues={{assestmentTitleID: assestmentTitleID, assestmentID: assestmentID,
                    assestmentTitleName: assestmentTitleName,
                    defination: defination,
                    definationBangla: definationBangla,indicatorName: indicatorName, active: active}}
                onSubmit={onSubmit}>
                {formik =>
                    (<>
                        <Form>
                            <Field type="hidden" name="assestmentTitleID"/>
                          {/*  <label>assessment</label>
                            <Field as="select" id="assestmentID"  name="assessment"  onChange={onAssessmentChange}  className='form-select'>
                                {activeAssestmentNames.map(option=>(
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </Field>*/}
                            <ErrorMessage name="assessment" component='div' className='text-danger'/>
                            <FormSelect id="assestmentID" name="assessment" options={activeAssestmentNames}/>
                            <TextField label={'Title Name'} type="text" name="assestmentTitleName"/>
                            <TextField label={'Definition'} type="text" name="defination"/>
                            <Field label={'definition Bangla'} type="hidden" value="N/A" name="definationBangla"/>
                            <TextField label={'indicator Name'} type="text" name="indicatorName"/>
                            <PMSCheckBox label={'Active'} name={'active'} id={'active'}/>
                            {isLoading ? <ProgressSpinner style={ {height:30,width:30} }/> : <button type="submit" disabled={isLoading} className="btn btn-primary">{assestmentTitleID === 0 ? 'Save' : 'Update'} </button>}

                        </Form>
                    </>)}

            </Formik>
        </BootstrapModal>
    </>)
}

export default AssestmentTitleForm